import { UploadFail } from 'reactApp/modules/uploading/fails/UploadFail';

export class HashCalcError extends UploadFail {
    radarName = 'filehash_fail';
    message = 'Не удалось посчитать хэш файла.';
}
